import styled from "styled-components";
import { SectionContainer, SectionTitle } from "../Section/Section.styled";
import { SubSectionContainer } from "components/SubSection/SubSection.styled";
import { Highlight } from "components/Hightlight/Hightlight.style";
import {
  CardContainer,
  ClientMessage,
} from "components/Cards/ClientCard/ClientCard.styled";

export const PageSections = styled.div`
  ${SectionContainer} {
    &:nth-child(odd) {
      background-color: ${(props) => props?.theme.colors.white};
      color: ${(props) => props?.theme.colors.dark};
      ${SectionTitle} {
        text-align: left;
        color: ${(props) => props?.theme.colors.dark};
      }

      ${CardContainer} {
        background-color: ${(props) => props?.theme.colors.dark};

        ${ClientMessage} {
          color: ${(props) => props?.theme.colors.white};
        }
      }
    }
    &:nth-child(even) {
      background-color: ${(props) => props?.theme.colors.dark};
      color: ${(props) => props?.theme.colors.white};
      ${SectionTitle} {
        text-align: right;
        color: ${(props) => props?.theme.colors.white};
      }

      ${CardContainer} {
        color: ${(props) => props?.theme.colors.dark};
      }
    }
    &:last-of-type {
      background-color: ${(props) => props?.theme.colors.white};
      color: ${(props) => props?.theme.colors.dark};
      ${SectionTitle} {
        color: ${(props) => props?.theme.colors.dark};
      }
    }
  }

  ${SubSectionContainer} ${Highlight} {
    font-stretch: normal;
  }

  ${CardContainer} {
    margin: 20px auto 80px;
  }

  @media (max-width: 1024px) {
    ${CardContainer} {
      width: 100%;
      margin-bottom: 20px;
    }
  }
`;
